module.exports = __webpack_public_path__ + "static/media/socialnetwork.c0c36ae5.svg";